export default __webpack_public_path__ + "static/media/4.787f7da7.jpg";